import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const jsonEditorStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalStyle: {
      display: 'flex',
      p: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    popup: {
      position: 'relative',
      width: '80%',
      background: '#FFFFFF',
      border: '2px solid #000',
      display: 'flex',
      flexDirection: 'column',
      zIndex: 100,
      color: '#000',
      borderRadius: 10,
      boxShadow: '0 0 20px 0 #444',
    },
    smallPopup: {
      position: 'relative',
      width: 650,
      background: '#FFFFFF',
      border: '2px solid #000',
      display: 'flex',
      flexDirection: 'column',
      zIndex: 100,
      color: '#000',
      borderRadius: 10,
      boxShadow: '0 0 20px 0 #444',
      padding: '0 30px 30px 10px',
      maxHeight: '70vh',
      overflowY: 'auto',
    },
    error: {
      color: '#d32f2f',
      marginBottom: 10,
    },
    tab: {
      color: '#FFFFFF',
      opacity: '0.6',
      fontSize: '1rem',
      fontFamily: 'serif',
      cursor: 'pointer',
      padding: 5,
      borderBottom: '1px solid black',
      borderRight: '1px solid black',
      alignItems: 'center',
      textAlign: 'center',
      '&:hover':{
        opacity: '0.8',
      }
    },
    actionSpace:{
      display: 'flex',
      cursor: 'default',
      flex: 1,
    },
    pointer: {
      cursor: 'pointer',
    },
    selectedTab: {
      backgroundColor: '#696969',
      borderRight: 'none',
      opacity: '1',
    },
    flexCol: {
      display: 'flex',
      flexDirection: 'column',
    },
    flex: {
      flex: 1,
    },
    flexColfill: {
      display: 'flex',
      flexDirection: 'column',
      flexBasis: '100%',
      flex: '1',
      padding: '10vh',
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
      overflow: 'auto',
    },
    flexRowWrap: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    flexSpacedRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      flex: '1',
    },
    border: {
      margin: '10px 0 20px 0',
      background: '#ebecF0',
      border: '1px solid grey',
      borderRadius: '5px',
      padding: '10px',
    },
    header: {
      width: '100%',
      height: '60px',
      alignItems: 'center',
      background: '#373737',
      color: '#FFFFFF',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',

      '& div': {
        marginLeft: 10,
      },
    },
    footer: {
      marginTop: 10,
      display: 'flex',
      flexDirection: 'row-reverse',
      '& button': {
        marginLeft: '1rem',
      },
    },
    alignCenter: {
      alignItems: 'center',
    },
    alignBase: {
      alignItems: 'baseline',
    },
    delete: {
      border: '1px solid grey',
      marginRight: '1rem',
      cursor: 'pointer',
      backgroundColor: 'red',
    },
    input: {
      borderRadius: '5px',
      padding: '8px',
      width: '400px',
    },
    mt1: {
      marginTop: '1rem',
    },
    mb1: {
      marginBottom: '1rem',
    },
    form: {
      width: '500px',
    },
    actionName: {
      marginRight: '1rem',
    },
    policyEntry: {
      height: '30px',
    },
    label: {
      width: '330px',
    },
    value: {
      marginLeft: '1rem',
      width: '200px',
    },
    icon: {
      cursor: 'pointer',
      marginLeft: '0.5rem',
    },
    leftContent: {
      overflowY: 'auto',
    },
    policyBody: {
      flex: 1,
      maxHeight: '70vh',
      padding: '10px',

      '& > div': {
        width: '100%',
      },
    },
    showPolicy: {
      overflowY: 'scroll',
      paddingLeft: '10px',
      flexBasis: '40%',
      flex: 1,

      '&::-webkit-scrollbar': {
        width: '10px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#1976d2',
        borderRadius: '1ex',
        boxShadow: '0px 1px 2px rgba(0,0,0,0.75)',
      },
    },

    heading: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginTop: '1rem',
      marginBottom: '0.5rem',
    },
    subHeading: {
      marginBottom: '0.5rem',
      fontSize: '1rem',
      fontWeight: 'bold',
    },
    startOverColor:{color: '#FF9171'},
    runFCColor:{color: '#83BF5D'},
    downloadColor: { color: '#0074d9' },
    downloadXMLColor: { color: '#8561c5' },
    addFlowchartColor: { color: '#FF9E2B'},
    TOSColor:{color: '#FFFF00'},
    leftMenuBar: {
      width: 90,
      backgroundColor: '#404040',
      overflowY: 'auto',
      overflowX: 'hidden'
    },
    iconBorder: {
      padding: '10px',
    },
    leftMainDivider:{
      width: '6px',
      backgroundColor: '#696969',
      borderRight: '1px solid #000000',
    },
    mainSection: {
      flex: 1,
    },
    mainRightDivider:{
      width: '6px',
      backgroundColor: '#696969',
      borderLeft: '1px solid #000000',
    },
    rightMenuBar: {
      width: 250,
      backgroundColor: '#404040',
      overflowY: 'auto',
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    },
    flowchartSelector:{
      paddingTop: 20,
      borderTop: '6px solid #696969',
      borderRight: '6px solid #696969',
    },
    claimSection: {
      padding: 10,
      height: '100%',
    },
    overFlowYScroll:{
      overflowY: 'auto',
    },
    attributeSection: {
      height: 300,
      overflowY: 'auto',
      marginBottom: 50,
    },
  }),
);

export { jsonEditorStyles };
